import { Link } from "react-router-dom";
export default function CtaSection() {
  return (
    <section className="section-space bg-[#EDE8DC]">
      <div className="shell cta-layout">
        <div>
          <p className="eyebrow">Pulling together</p>
          <h2>
            Bring your ambition.
            <br />
            Let’s find the next step.
          </h2>
          <p className="body-copy">
            A learning goal, an enterprise idea, or a shared development
            priority — we welcome the conversation.
          </p>
        </div>
        <Link className="button button-green" to="/contact#contact-form">
          Start a Conversation <span aria-hidden="true">↗</span>
        </Link>
      </div>
    </section>
  );
}
